module.exports = __webpack_public_path__ + "static/media/school.7d676b42.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/school.jpg
// module id = 1288
// module chunks = 0